class FooterMenu {
	constructor(el,opt){
		this.el = el;
		this.event();
	}
	event(){
    $( '.js-f-menu' ).on( 'click', function() {
      $( this ).toggleClass( 'add-active' );
      $( this ).next().slideToggle();
    });
	}
}

